import { render } from "./PrivacyView.vue?vue&type=template&id=285546ec"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=285546ec&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__